import { collection, addDoc, getDocs, updateDoc, doc, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Get all products
export const getAllProducts = async () => {
  const productsRef = collection(db, 'products');
  const querySnapshot = await getDocs(productsRef);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

// Add new product with URL
export const addProductsToDb = async (products) => {
  const productsRef = collection(db, 'products');
  
  for (const product of products) {
    try {
      await addDoc(productsRef, {
        styleNo: product.styleNo,
        description: product.description,
        shortDescription: product.shortDescription || '',
        supplierUrl: product.supplierUrl || '',
        cogs: product.cogs || 0,
        createdAt: new Date()
      });
    } catch (error) {
      console.error('Error adding product:', product.styleNo, error);
    }
  }
};

// Get product by style number
export const getProductByStyle = async (styleNo) => {
  const productsRef = collection(db, 'products');
  const querySnapshot = await getDocs(productsRef);
  const doc = querySnapshot.docs.find(doc => doc.data().styleNo === styleNo);
  if (doc) {
    return {
      id: doc.id,
      ...doc.data()
    };
  }
  return null;
};

// Update product URL
export const updateProductUrl = async (productId, url) => {
  const productRef = doc(db, 'products', productId);
  await updateDoc(productRef, {
    supplierUrl: url,
    updatedAt: new Date()
  });
};

// New function to update or add supplier URLs to existing products
export const updateProductSupplierUrls = async (urlMappings) => {
  const productsRef = collection(db, 'products');
  
  for (const [styleNo, url] of Object.entries(urlMappings)) {
    try {
      // Find the product by styleNo
      const q = query(productsRef, where('styleNo', '==', styleNo));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const productDoc = querySnapshot.docs[0];
        await updateDoc(doc(db, 'products', productDoc.id), {
          supplierUrl: url,
          updatedAt: new Date()
        });
        console.log(`Updated URL for style ${styleNo}`);
      } else {
        console.log(`Product not found: ${styleNo}`);
      }
    } catch (error) {
      console.error(`Error updating URL for style ${styleNo}:`, error);
    }
  }
};

// New function to update product descriptions
export const updateProductDescriptions = async (productId, { description, shortDescription }) => {
  const productRef = doc(db, 'products', productId);
  await updateDoc(productRef, {
    description,
    shortDescription,
    updatedAt: new Date()
  });
}; 